import { useState } from 'react';

import { defaultTo } from 'ramda';
import { useTranslation } from 'react-i18next';

import { DTRRule } from './types';

import { LoadingError } from 'components/shared/LoadingError/LoadingError';

import { EditDTRRuleDrawer } from './components/EditDTRRuleDrawer';

import { useGetColumns } from './hooks/useGetColumns';
import { useGetDTRRulesTableData } from './hooks/useGetDTRRulesTableData';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import { StyledTableBoxWrapper } from 'components/shared/Box/Box.styles';

const DTRRules = () => {
  const { t } = useTranslation();
  const columns = useGetColumns();

  const { isFetching, data, error, refetch } = useGetDTRRulesTableData();

  const [pageSize, setPageSize] = useState<number>(20);
  const [selectedRow, setSelectedRow] = useState<DTRRule>();
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const handleOpenDrawer = (
    id: number | string,
    selectedRow: DTRRule | undefined
  ) => {
    setSelectedRow(selectedRow);
    setOpenDrawer(true);
  };

  return (
    <>
      {error ? (
        <LoadingError reFetch={() => refetch()} />
      ) : (
        <StyledTableBoxWrapper>
          <TableCRUDLayout
            customActions={[
              {
                onClick: handleOpenDrawer,
                icon: 'pen',
                tooltipTitle: t('details') as string
              }
            ]}
            hideCreateAction
            editable={false}
            onPaginationModelChange={({ pageSize }) => setPageSize(pageSize)}
            getRowId={(data: DTRRule) => data.dtrRuleId}
            loading={isFetching}
            rows={defaultTo([], data)}
            pagination
            pageSizeOptions={[50, 20, 10]}
            pageSize={pageSize}
            columns={columns}
            initialState={{
              sorting: {
                sortModel: [{ field: 'name', sort: 'asc' }]
              }
            }}
          />
        </StyledTableBoxWrapper>
      )}
      {selectedRow && (
        <EditDTRRuleDrawer
          open={openDrawer}
          selectedRow={selectedRow}
          onClose={handleCloseDrawer}
        />
      )}
    </>
  );
};

export default DTRRules;
